import React from "react";
import AnnualReports from "./AnnualReports";
import MarketingOpportunitiesForMinorityArtisans from "./MarketingOpportunitiesForMinorityArtisans";
import MinorityConcentratedBlocks from "./MinorityConcentratedBlocks";
import MinorityConcentratedDistricts from "./MinorityConcentratedDistricts";
import MgtSeven from "./MgtSeven";
import ImpactEvaluationStudy from "./ImpactEvaluationStudy";
import ResourceDocuments from "./ResourceDocuments";
import Csr from "./Csr";
import NmdfcPolicies from "./NmdfcPolicies";
import KskProjectDetails from "./KskProjectDetails";
import FposStateWiseDetails from "./FposStateWiseDetails";
import LendingPolicy from "./LendingPolicy";
import ResourceSectionPlaceholder from "./ResourceSectionPlaceholder";

const ResourcesContent = ({ activeSection, currentSection, resourceDocument }) => {
  if (activeSection === "annual-reports") {
    return <AnnualReports />;
  }

  if (activeSection === "marketing-opportunities-for-minority-artisans") {
    return <MarketingOpportunitiesForMinorityArtisans />;
  }

  if (activeSection === "minority-concentrated-blocks") {
    return <MinorityConcentratedBlocks />;
  }

  if (activeSection === "minority-concentrated-districts") {
    return <MinorityConcentratedDistricts />;
  }

  if (activeSection === "mgt-7") {
    return <MgtSeven />;
  }

  if (activeSection === "impact-evaluation-study") {
    return <ImpactEvaluationStudy />;
  }

  if (activeSection === "resource-documents") {
    return <ResourceDocuments activeDocument={resourceDocument} />;
  }

  if (activeSection === "memorandum-of-understanding") {
    return <ResourceDocuments activeDocument="memorandum-of-understanding" />;
  }

  if (activeSection === "memorandum-of-association") {
    return <ResourceDocuments activeDocument="memorandum-of-association" />;
  }

  if (activeSection === "csr") {
    return <Csr />;
  }

  if (activeSection === "nmdfc-policies") {
    return <NmdfcPolicies />;
  }

  if (activeSection === "ksk-project-details") {
    return <KskProjectDetails />;
  }

  if (activeSection === "fpos-state-wise-details") {
    return <FposStateWiseDetails />;
  }

  if (activeSection === "lending-policy") {
    return <LendingPolicy />;
  }

  return <ResourceSectionPlaceholder title={currentSection.label} />;
};

export default ResourcesContent;
